import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import withHooks from '../../../core/withHooks';
import { NavigationBar } from '@clockout-dev/design-elements';
import { navbarSections } from './navbar.constants';
import { NAVBAR_BRAND_PATH } from './navbar.paths';
import NewSidebarController from './newSidebar.controller';
import SidebarFooter from './elements/SidebarFooter';
import { userHasScope } from '../../../constants/scopes.constants';

class NewSidebar extends Inherit(NewSidebarController, Component) {
    render() {
        const user = this.props.user ?? this.data?.user;
        const fi = this.props.fi ?? user?.fi?.name;

        const brand = {
            logo: <img src="/logo-color.png" alt="Clockout Logo" />,
            title: user?.name,
            subtitle: fi,
            onClick: () => this.props.navigate(NAVBAR_BRAND_PATH)
        };

        const currentPath = this.resolveNavbarActivePath(this.props.location);
        const { classNames: classNamesProp, collapsible = true } = this.props;
        const visibleSections = navbarSections.filter((section) =>
            userHasScope(user, section.requiredScope)
        );

        return (
            <NavigationBar
                classNames={classNamesProp}
                sections={visibleSections}
                brand={brand}
                currentPath={currentPath}
                onNavigate={this.handleNavigate.bind(this)}
                expandedWidth={260}
                collapsible={collapsible}
                footer={<SidebarFooter user={user} />}
            />
        );
    }
}

export default withHooks(NewSidebar);
